module.exports = __webpack_public_path__ + "static/media/help_2.f63bb90f.jpg";